module.exports = __webpack_public_path__ + "img/DAO-alt.894644f3.svg";